module.exports = __webpack_public_path__ + "static/img/banner1.cb369cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/banner1.jpg
// module id = WeRx
// module chunks = 1